export default {
  tickets: [],
  ticketsIndicator: {},
  emptyTicket: {
    files: [],
    priority: 'Normal',
    type: 'Issue',
    status: 'New'
  },
  params: {
    entity: [
      'files'
    ],
    collection: []
  },
  ticketsContext: {}
}